class StickyHeader extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			headerId: "header",
			headerWrapper: ".header-wrapper",
			headerTopLinks: ".top-bar",
			bottomBar:".announcement-bottom-bar-container",
			sideMenuId: "side-menu",
			sideMenu: {
				sideDrawerToggle: ".js-side-menu-toggle",
				sideDrawerOpeners: ".js-side-menu-open",
				sideDrawerClosures: ".js-side-menu-close"
			}
		};

		this.headerCssVariables = {
               headerHeight: '--header-height',
			   headerMobileHeight: '--header-height--mobile',
			   topBarHeight: '--top-bar-height',
			   announcementBarHeight: '--announcement-bar-height'
		};

		this.modifiers = {
			hiddenTopBar: "header--top-bar-hidden",
			hiddenAnnouncement:'header--announcement-hidden',
			isHeaderSimplified: "is-header-simplified"
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.onResizeHandler = this.onResize.bind(this);
	}

	connectedCallback() {

		this.header = this;
		this.currentScrollTop = 0;
		this.headerWrapper = this.header.querySelector(this.selectors.headerWrapper);
		this.headerTopBar = this.header.querySelector(this.selectors.headerTopLinks);
		this.headerBottomBar = this.header.querySelector(this.selectors.bottomBar);
		this.headerHeight = 0;

		this.attachListeners();
		this.onResize();
	}

	disconnectedCallback() {
		window.removeEventListener("scroll", this.onScrollHandler, false);
		window.removeEventListener("resize", this.onResizeHandler, false);
	}

	attachListeners() {
		window.addEventListener("scroll", this.onScrollHandler, false);
		window.addEventListener("resize", this.onResizeHandler, false);
	}

	onResize() {

		this.headerHeight = this.header.getBoundingClientRect().height;

		document.documentElement.style.setProperty(
			this.headerCssVariables.headerHeight,
			`${this.headerHeight}px`
		);

		document.documentElement.style.setProperty(
			this.headerCssVariables.headerMobileHeight,
			`${this.headerHeight}px`
		);

		document.documentElement.style.setProperty(
			"--header-wrapper-height",
			`${this.headerWrapper.getBoundingClientRect().height}px`
		);

		if (this.headerTopBar) {
			document.documentElement.style.setProperty(
				"--header-top-bar-height",
				`${this.headerTopBar.getBoundingClientRect().height}px`
			);
		}

		if (this.headerBottomBar) {
			document.documentElement.style.setProperty(
				"--header-announcement-height",
				`${this.headerBottomBar.getBoundingClientRect().height}px`
			);
		}
	}

	onScroll() {
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;
		if (scrollTop > this.headerHeight) {
			requestAnimationFrame(this.hideAnnouncementBar.bind(this));

			if (scrollTop >= this.currentScrollTop) {
				requestAnimationFrame(this.hideBars.bind(this));
			} else if (scrollTop < this.currentScrollTop) {
				requestAnimationFrame(this.showBars.bind(this));
			}

		} else {
			requestAnimationFrame(this.showAnnouncementBar.bind(this));
		}


		this.currentScrollTop = scrollTop;
	}

	showAnnouncementBar() {
		this.header.classList.remove(this.modifiers.hiddenAnnouncement);
	}

	hideAnnouncementBar() {
		this.header.classList.add(this.modifiers.hiddenAnnouncement);
	}

	showBars() {
		this.header.classList.remove(this.modifiers.hiddenTopBar);
		document.body.classList.remove(this.modifiers.isHeaderSimplified);
	}

	hideBars() {
		this.header.classList.add(this.modifiers.hiddenTopBar);
		document.body.classList.add(this.modifiers.isHeaderSimplified);
	}
}

customElements.define('sticky-header', StickyHeader);
